import { Button } from '@ahmdigital/ui';
import styled from 'styled-components';

const PriceBarWrapper = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 0;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    gap: 1rem;
    flex-wrap: nowrap;
    border: none;
  }
`;

const TotalPriceWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: normal;
  height: auto;
  padding-left: 0.5rem;
  border-left: 1px solid ${({ theme }) => theme.colors.grey20};
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    padding-left: 1rem;
  }
`;

const SelectedProductsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    gap: 1rem;
    flex-direction: row;
    border: none;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    flex-direction: row;
    flex-basis: unset;
    width: unset;
  }
`;

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  min-width: 300px;
  font-size: 1.25rem;
  padding: 1rem;
`;

interface ProductPriceWrapperProps {
  isSelected?: boolean;
}

const ProductPriceWrapper = styled.div<ProductPriceWrapperProps>`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.25rem;
  color: ${({ theme, isSelected }) => (isSelected ? theme.colors.black : theme.colors.grey60)};
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.colors.grey10 : theme.colors.white)};
  transition-property: background-color, color;
  transition-duration: 0.6s;
  transition-timing-function: cubic-bezier(0.09, 0.94, 0.42, 0.98);
  min-width: 250px;
  gap: 1rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    padding: 1rem;
  }
`;

export {
  PriceBarWrapper,
  TotalPriceWrapper,
  SelectedProductsWrapper,
  ButtonWrapper,
  StyledButton,
  ProductPriceWrapper,
};
